import React from 'react'
import { Select } from 'antd'
import { CompaniesModels } from '@getgreenline/companies'
import { GlobalDynamicVariables } from '@/app/constants/GlobalDynamicVariables'
import { Country } from '@getgreenline/homi-shared'

export const StateOrProvinceDropdown = (props: {
  stateOrProvince: CompaniesModels.Provinces | null
  onChange: (province: CompaniesModels.Provinces | null) => void
  country?: Country
  hideLabel?: boolean
  width?: number | string
  allowNone?: boolean
}) => {
  const stateOrProvince = GlobalDynamicVariables.vars.stateOrProvince(props.country)
  const allowNone = props.allowNone !== undefined ? props.allowNone : false
  return (
    <React.Fragment>
      {!props.hideLabel && (
        <label>{GlobalDynamicVariables.labels.stateOrProvince(props.country)}</label>
      )}
      <div>
        <Select<CompaniesModels.Provinces | null>
          style={{ width: props.width || '100%' }}
          value={props.stateOrProvince}
          onChange={props.onChange}
        >
          {allowNone && (
            <Select.Option key='none' value={null as unknown as CompaniesModels.Provinces}>
              None
            </Select.Option>
          )}
          {Object.values(stateOrProvince)
            .sort()
            .map((sp) => (
              <Select.Option key={sp} value={sp}>
                {sp}
              </Select.Option>
            ))}
        </Select>
      </div>
    </React.Fragment>
  )
}
